/**
 * @generated SignedSource<<55e2f137a0b89250c388c16b7ce4f7bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedContactSellerButton_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_item">;
  readonly " $fragmentType": "PdpSharedContactSellerButton_item";
};
export type PdpSharedContactSellerButton_item$key = {
  readonly " $data"?: PdpSharedContactSellerButton_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactSellerButton_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedContactSellerButton_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "452741c1ca3376ede3ffcf7111f6ddd8";

export default node;
